// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { TankRoutingModule } from './tank-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { AddDocumentToTankDialogComponent } from "src/app/modules/tank/components/add-document-to-tank-dialog/add-document-to-tank-dialog.component";
import { TankListComponent } from 'src/app/modules/tank/pages/tank-list/tank-list.page';
import { EditTankDocumentDialogComponent } from './components/edit-tank-document-dialog copy/edit-tank-document-dialog.component';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    TankRoutingModule,
    // PublicModule,
  ],
  declarations: [
    TankListComponent,
    AddDocumentToTankDialogComponent,
    EditTankDocumentDialogComponent,
  ],
  entryComponents: [
    AddDocumentToTankDialogComponent,
    EditTankDocumentDialogComponent,
  ],
  exports: [
    AddDocumentToTankDialogComponent,
    EditTankDocumentDialogComponent,
  ]
})
export class TankModule { }
